import React from 'react';
import { isNil } from 'ramda';

import LogPresenter from '../../../../../../../presenters/LogPresenter';

const Log = (props) => {
  const { log } = props;
  const hasMeta = !isNil(LogPresenter.meta(log));

  return (
    <React.Fragment>
      <tr>
        <td>{LogPresenter.detailedFormattedDate(log)}</td>
        <td>{LogPresenter.eventTypeReadable(log)}</td>
        <td>
          <div>{hasMeta && LogPresenter.printMeta(log)}</div>
        </td>
      </tr>
    </React.Fragment>
  );
};

export default Log;

Log.propTypes = {
  log: LogPresenter.shape().isRequired,
};
